<template>
    <div class="admin-home">
        <div class="content-container">
            <div class="header">
                <div class="title">Reported posts</div>
                <div class="toggleCleared">
                  <input type="checkbox" @change="refreshPosts" v-model="viewCleared">
                  <div class="viewClearedLabel">View Cleared</div>
                </div>
            </div>                    
            <div class="content" v-if="reportedPosts">
              <div v-for="post in reportedPosts" :key="post.id">
                <reported-post :post="post" />
              </div>
            </div>
        </div>        
        <div class="content-container">
            <div class="header">
                <div class="title">Posts Pending Approval</div>
            </div>
            <div class="content">
                <div class="items">
                    <ReviewPendingPostItem v-for="post in pendingPosts" :key="post.postID" :post="post"></ReviewPendingPostItem>
                </div>    
            </div>
        </div>
        <div class="content-container">
            <div class="header">
                <div class="title">Topics Pending Approval</div>
            </div>
            <div class="content">
                <div class="items">
                    <ReviewPendingTopicItem 
                        v-for="topic in pendingTopics" 
                        :key="topic.topicID" 
                        :topic="topic"
                        @admin-topic-approved="adminTopicApproved"
                        @admin-topic-deleted="adminTopicDeleted"></ReviewPendingTopicItem>
                </div>
            </div>
        </div>
        
    </div>
</template>


<script>

    import ReviewPendingPostItem from '../../components/Admin/ReviewPendingPostItem.vue'
    import ReviewPendingTopicItem from '../../components/Admin/ReviewPendingTopicItem.vue'
    import ReportedPost from '../../components/Admin/ReportedPost';
    import api from '../../api/api'

    export default {
        data() {
            return {
                pendingPosts: [],
                pendingTopics: [],
                reportedPosts: [],  // this is the list that's visible, it'll toggled between cleared/uncleared
                reportedAll: [],    // this is the list that contains all of it...
                reportedPostsUncleared: [],
                reportedPostsCleared: [],
                viewCleared: false
            }
        },
        components: {
            ReviewPendingPostItem,
            ReviewPendingTopicItem,
            ReportedPost
        },
        methods: {
            adminTopicApproved: function(topicID) {
                for (var i = 0; i < this.pendingTopics.length; i++) {
                    if (this.pendingTopics[i].topicID == topicID) {
                        this.pendingTopics.splice(i, 1);
                        break;
                    }
                }
            },
            adminTopicDeleted: function(topicID) {
                for (var i = 0; i < this.pendingTopics.length; i++) {
                    if (this.pendingTopics[i].topicID == topicID) {
                        this.pendingTopics.splice(i, 1);
                        break;
                    }
                }
            },
            refreshPosts(){

              api.get('/admin/reportedPosts')
                .then((r) => {
                  this.reportedPosts = null;
                  this.$nextTick(() => {
                    var all = r.data;
                    var cleared = this.clearedOnly(all);
                    var uncleared = this.unclearedOnly(all);
                    this.reportedAll = all;
                    this.reportedPostsCleared = cleared;
                    this.reportedPostsUncleared = uncleared;
                    this.reportedPosts = this.viewCleared === true ? cleared : uncleared;                  
                  });
                });
            },
            unclearedOnly: function(allReported) {
                return allReported.filter(x => x.postReported === true);
            },
            clearedOnly: function(allReported) {
                return allReported.filter(x => x.postReported === false);
            }
        },
        mounted() {
            api.get('/admin/review')
                .then(response => {
                    this.pendingPosts = response.data.postsPendingApproval;
                    this.pendingTopics = response.data.topicsPendingApproval;
                })
                .catch(() => {
                    this.$router.replace({path: '/error'});
                });
            
            api.get('/admin/reportedPosts')
              .then((r) => {
                    var all = r.data;
                    var cleared = this.clearedOnly(all);
                    var uncleared = this.unclearedOnly(all);
                    this.reportedAll = all;
                    this.reportedPostsCleared = cleared;
                    this.reportedPostsUncleared = uncleared;
                    this.reportedPosts = this.viewCleared === true ? cleared : uncleared;
              });
        }
    }
</script>
